module.exports = __webpack_public_path__ + "static/media/horrormax-banner-a-wich-story.63d17804.jpg";